import { render, staticRenderFns } from "./ContactReportTaskForm.vue?vue&type=template&id=18e54cc7"
import script from "./ContactReportTaskForm.vue?vue&type=script&lang=js"
export * from "./ContactReportTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports